import { useEffect } from "react";

const RegistSuccess = () => {
    
    useEffect(() => {
        document.title = 'Организация зарегистрирована | Личный кабинет Брокера THE FIVE';
    }, [])

    return (
        <div className="page-auth">
            <div className="page-auth__img"></div>
            <div className="page-auth__content">
                <div className="logo"></div>

                <div className="auth-info fadeIn">
                    <div className="auth-info__title">Организация зарегистрирована</div>
                    <div className="auth-info__text">Данная организация зарегистрирована<br/>в&nbsp;Личном кабинете агента. Обратитесь<br/>к&nbsp;своему администратору.</div>
                    <div className="auth-info__links">
                        <a href="/" className="btn">На главную</a>
                    </div>                 
                </div>
            </div>
        </div>
    )
}

export default RegistSuccess;